import Layout from "@/layouts/default/main"
export default {
    path: "/auth",
    name: "Auth",
    redirect: "/auth/index",
    component: Layout,
    children: [{
        path: "index",
        name: "AuthIndex",
        component: () => import("@/views/auth/index")
    }]
}